export function createBaseMediaProvider() {
    return {
        resolveMediaAsset() {
            return undefined;
        },
    };
}
